import React from 'react';
import './contactus.css';

function ContactUs() {
    return (

    <section id="contact-1184">
        <div className="cs-container">
            <picture className="cs-background">
                <source media="(max-width: 600px)" srcSet="/images/sai-baba.jpg"></source>
                <source media="(min-width: 601px)" srcSet="/images/sai-baba.jpg"></source>
                <img loading="lazy" decoding="async" src="/images/sai-baba.jpg" alt="Sai Center Milwaukee" width="637" height="726"></img>
            </picture>
            <div className="cs-content">
                <span className="cs-topper">Connect</span>
                <h2 className="cs-title">Sri Sathya Sai Milwaukee Center</h2>
                <div className="cs-info-group">
                    <div className="cs-info">
                        <span className="cs-topper">Location</span>
                        <span className="cs-detail">2418 W Mangold Ave,<br />Milwaukee, WI 53221</span>
                    </div>
                    <div className="cs-info">
                        <span className="cs-topper">Center Hours</span>
                        <span className="cs-detail">Sunday: 2:30 - 5:30 pm</span>
                        <span className="cs-detail">Service Activity: 2:30 - 3:00 pm</span>
                        <span className="cs-detail">Bal Vikas / SSE: 3:00 - 4:00 pm</span>
                        <span className="cs-detail">Study Circle: 3:00 - 4:00 pm</span>
                        <span className="cs-detail">Bhajans: 4:00 - 5:00 pm</span>
                        <span className="cs-detail">Social: 5:00 - 5:30 pm</span>
                    </div>
                    <div className="cs-info">
                        <span className="cs-topper">Contact</span>
                        <span className="cs-detail">M: (414) 301-2753</span>
                        <span className="cs-detail">E: saicenter.milwaukee@gmail.com</span>
                    </div>
                </div>
            </div>
            <div className="cs-cta">
                <h3 className="cs-h3">Experience Transformation</h3>
                <p className="cs-cta-p">
                    by practicing <strong>Devotion</strong>, <strong>Discrimination</strong>, <strong>Determination</strong>, <strong>Discipline</strong> and <strong>Duty</strong>.
                </p>
            </div>
        </div>
    </section>

    );  
}

export default ContactUs;